import LoginBackground from 'assets/images/login-background.jpg';
import styled from 'styled-components';
import { Colors } from 'styles/constants';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 940px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  @media screen and (max-width: 980px) {
    flex-direction: column;
    max-width: 640px;
    div.art-container {
      flex: 0 0 auto;
      height: 48px;
      width: 100%;
    }
  }
`;

// Email form

export const FormContainer = styled.div.attrs({ className: 'form-container' })`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  background: ${Colors.White};
  padding: 30px 40px;
`;

export const Logo = styled.figure`
  margin-bottom: 30px;
`;

export const LogoImage = styled.img`
  width: 251px;
`;

export const Header = styled.header`
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 28px;
  margin-bottom: 1rem;
  @media screen and (max-width: 980px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  span {
    font-weight: bold;
  }
`;

// art

export const ArtContainer = styled.div.attrs({ className: 'art-container' })`
  display: flex;
  flex: 0 0 370px;
  width: 370px;
  background: url(${LoginBackground});
  background-position: center;
  background-size: cover;
`;
